import React, { useState, useEffect } from 'react';
import './EquipmentModal.css';

const fixedReceiverOptions = [
  "Radiateur électrique",
  "Chauffe-eau",
  "VMC (Ventilation Mécanique Contrôlée)",
  "Climatiseur",
  "Four encastré",
  "Plaque de cuisson",
  "Hotte aspirante",
  "Sèche-serviettes",
  "Convecteur",
  "Pompe à chaleur",
  "PIANO DE CUISSON",
  "FOUR",
  "HOTTE EXTRACTION",
  "MEUBLE RÉFRIGÉRÉ",
  "MEUBLE FROID",
  "LAVE VAISSELLE",
  "CHAMBRE FROIDE POSITIVE",
  "CHAMBRE FROIDE NEGATIVE",
  "CHAMBRE DE POUSSE",
  "CHAMBRE DE FERMENTATION",
  "BALANCELLE",
  "DIVISEUSE"
];

const ISOLEMENT_OPTIONS = ["1", "10", "M", "B", "<0,5", ">0,5", "100"];

export default function RecepteursFixesModal({ isOpen, onClose, onSave, local, equipment }) {
  const [formData, setFormData] = useState({
    category: 'recepteurs_fixes',
    name: '',
    existing_quantity: 1,
    verified_quantity: 1,
    protection_type: 'D',
    protection_type_other: '',
    continuity_result: 'Bon',
    isolement: '',
    result: 'conforme'
  });

  const [showOtherProtection, setShowOtherProtection] = useState(false);

  useEffect(() => {
    if (equipment) {
      setFormData(equipment);
      setShowOtherProtection(equipment.protection_type && !['D', 'PC', 'RT', 'FD'].includes(equipment.protection_type));
    }
  }, [equipment]);

  const handleProtectionChange = (value) => {
    setShowOtherProtection(value === 'other');
    setFormData({...formData, protection_type: value});
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.continuity_result) {
      alert('Veuillez remplir tous les champs obligatoires');
      return;
    }
    const finalEquipment = {
      type: 'recepteur_fixe',
      ...formData,
      protection_type: showOtherProtection ? formData.protection_type_other : formData.protection_type
    };
    onSave(finalEquipment);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="equipment-modal-overlay" onClick={onClose}>
      <div className="equipment-modal" onClick={(e) => e.stopPropagation()}>
        <div className="equipment-modal-header">
          <div>
            <h2 className="equipment-modal-title">⚡ Récepteurs Fixes</h2>
            <p className="equipment-modal-subtitle">{local?.nom}</p>
          </div>
          <button onClick={onClose} className="equipment-close-button">✕</button>
        </div>

        <form onSubmit={handleSubmit} className="equipment-form">
          <div className="equipment-form-scroll">
            <p className="equipment-info-text" style={{ marginBottom: '16px' }}>
              Ce formulaire permet d'ajouter des équipements fixes raccordés au réseau électrique.
            </p>

            <div className="equipment-form-group">
              <label className="equipment-form-label">
                Désignation du récepteur fixe <span className="equipment-required">*</span>
              </label>
              <input
                type="text"
                list="fixed-receiver-options"
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                className="equipment-form-input"
                placeholder="Sélectionnez ou saisissez une désignation"
                required
              />
              <datalist id="fixed-receiver-options">
                {fixedReceiverOptions.map(opt => <option key={opt} value={opt} />)}
              </datalist>
            </div>

            <div className="equipment-form-row">
              <div className="equipment-form-group">
                <label className="equipment-form-label">Quantité existante</label>
                <input
                  type="number"
                  min="0"
                  value={formData.existing_quantity}
                  onChange={(e) => setFormData({...formData, existing_quantity: parseInt(e.target.value)})}
                  className="equipment-form-input"
                />
              </div>
              <div className="equipment-form-group">
                <label className="equipment-form-label">Quantité vérifiée</label>
                <input
                  type="number"
                  min="0"
                  value={formData.verified_quantity}
                  onChange={(e) => setFormData({...formData, verified_quantity: parseInt(e.target.value)})}
                  className="equipment-form-input"
                />
              </div>
            </div>

            <div className="equipment-form-group">
              <label className="equipment-form-label">Type de protection</label>
              <select
                value={showOtherProtection ? 'other' : formData.protection_type}
                onChange={(e) => handleProtectionChange(e.target.value)}
                className="equipment-form-select"
              >
                <option value="D">D</option>
                <option value="PC">PC</option>
                <option value="RT">RT</option>
                <option value="FD">FD</option>
                <option value="other">Autre</option>
              </select>
              {showOtherProtection && (
                <input
                  type="text"
                  value={formData.protection_type_other}
                  onChange={(e) => setFormData({...formData, protection_type_other: e.target.value})}
                  className="equipment-form-input"
                  placeholder="Spécifier autre type de protection"
                  style={{ marginTop: '8px' }}
                  required
                />
              )}
            </div>

            <div className="equipment-form-group">
              <label className="equipment-form-label">
                Continuité PE <span className="equipment-required">*</span>
              </label>
              <select
                value={formData.continuity_result}
                onChange={(e) => setFormData(prev => ({
                  ...prev,
                  continuity_result: e.target.value,
                  isolement: e.target.value === 'Mauvais' ? '>0,5' : prev.isolement
                }))}
                className="equipment-form-select"
                required
              >
                <option value="">- Sélectionner -</option>
                <option value="Bon">Bon</option>
                <option value="Mauvais">Mauvais</option>
                <option value="Classe II">Classe II</option>
                <option value="NVE">NVE</option>
                <option value="NVI">NVI</option>
                <option value="NVX">NVX</option>
                <option value="SO-PI">SO-PI</option>
              </select>
            </div>

            <div className="equipment-form-group">
              <label className="equipment-form-label">Isolement (MΩ)</label>
              <input
                type="text"
                list="isolement-options-recepteurs"
                value={formData.isolement || ''}
                onChange={(e) => setFormData({...formData, isolement: e.target.value})}
                className="equipment-form-input"
                placeholder="Ex: >0,5, 1, 10, 100, M, B..."
              />
              <datalist id="isolement-options-recepteurs">
                {ISOLEMENT_OPTIONS.map(opt => <option key={opt} value={opt} />)}
              </datalist>
            </div>
          </div>

          <div className="equipment-form-buttons">
            <button type="button" onClick={onClose} className="equipment-cancel-button">
              ← Retour
            </button>
            <button type="submit" className="equipment-save-button">
              {equipment ? 'Mettre à jour' : '+ Ajouter rapidement'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}